import React from "react";
import { useLocation } from "react-router-dom";

export const app_url = process.env.REACT_APP_API_URL;

export const BEDTYPES = {
  SF: "Furnished <b>Studio</b>",
  "1F": "Furnished <b>1</b> Bedroom",
  "2F": "Furnished <b>2</b> Bedroom",
  "3F": "Furnished <b>3</b> Bedroom",
  "4F": "Furnished <b>4</b> Bedroom",
};

export const UNITTYPES = {
  SF: "Studio",
  "1F": "1 Bedroom",
  "2F": "2 Bedroom",
  "3F": "3 Bedroom",
  "4F": "4 Bedroom",
};

const MONTH = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const unitCount = (count) => {
  let reqCount;
  if (count < 20) {
    reqCount = "<20";
  } else if (count > 20 && count < 50) {
    reqCount = "20 - 50";
  } else if (count > 50 && count < 101) {
    reqCount = "51 - 100";
  } else if (count > 100) {
    reqCount = "100+";
  } else {
    reqCount = count;
  }
  return reqCount;
};

export const monthDashBoardData = (data, frequency) => {
  if (frequency === "month" && data !== undefined) {
    let lastMonth;
    let newData = data.reduce((acc, curr) => {
      let currData = curr.yearMonth;
      if (currData === lastMonth) {
        let currArr = acc.pop();
        currArr = [...currArr, curr];
        return (acc = [...acc, currArr]);
      } else {
        lastMonth = currData;
        return (acc = [...acc, [curr]]);
      }
    }, []);
    return { data: newData, isYearVisible: true };
  }

  let newData = data || [];
  return { data: newData, isYearVisible: false };
};

export const getMonth = (yearMonth) => {
  let currYear = yearMonth.toString().substring(0, 4);
  let monthNum = Number(yearMonth.toString().substring(4, 6));

  let currMon = MONTH[monthNum - 1];

  return `${currMon}/${currYear}`;
};

export const emailValidity = (inputValue) => {
  let pattern =
    /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
  return pattern.test(inputValue);
};

export const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
};

export const timeZoneAbbreviated = (date) => {
  let timezone = date.toString().match(/\(([A-Za-z\s].*)\)/)[1];
  var abbreviation = "";

  // We run a forEach dividing the timezone in words with split
  timezone.split(" ").forEach((word) => {
    // We insert the first letter of every word in the abbreviation variable
    abbreviation += word.split("")[0];
  });

  // And finally we return the abbreviation
  return abbreviation;
};

const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const dateString = (date) =>
  `Data current as of ${days[date.getDay()]}${" "}${date.toLocaleString(
    "default",
    { month: "short" }
  )} ${date.getDate()}${" "}${date.getHours()}${":"}${date.getMinutes()}${":"}${date.getSeconds()} ${timeZoneAbbreviated(
    date
  )} ${date.getFullYear()}`;

export const dateForExcel = (date) =>
  `Date: ${date.getDate()}/${date.toLocaleString("default", {
    month: "short",
  })}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;

export const excelFileName = (date) =>
  `DWL Market Rates – ${date.getFullYear()}-${date.getMonth() < 9 ? "0" : ""}${
    date.getMonth() + 1
  }-${date.getDate() <= 9 ? "0" : ""}${date.getDate()}-${
    date.getHours() <= 9 ? "0" : ""
  }${date.getHours()}_${
    date.getMinutes() <= 9 ? "0" : ""
  }${date.getMinutes()}_${
    date.getSeconds() <= 9 ? "0" : ""
  }${date.getSeconds()}.xlsx`;

export const disclaimer =
  "Rates shown indicate the average rate across all properties in this market for the given unit type, for the entire timeline selected. This average rate may include anomalies, such as VIP bookings or employee discounted rates. This information is to be considered as directional data for the purposes of establishing budget estimates and should not be construed as a binding price quote.";
